<template>
  <div class="row">
    <div
      v-if="loading"
      class="col-xs-12"
    >
      <div class="col-xs-12 text-center">
        <i class="fa fa-spinner fa-pulse fa-2x fa-fw" />
      </div>
    </div>
    <div
      v-else-if="events.length == 0"
      class="col-xs-12 text-center"
    >
      <p>Geen vragen bekend</p>
    </div>
    <div v-else>
      <div class="col-xs-2">
        <span
          v-show="event_index > 0"
          class="fa fa-chevron-left cursor-pointer change"
          @click="changeEventIndex(event_index - 1)"
        />
      </div>
      <div class="col-xs-8 text-center">
        <div v-if="activeEvent !== null">
          <small class="text-muted mr-3">
            <template v-if="activeEvent.type === 'class'">
              <a :href="'/employee/courses/' + activeEvent.course_id + '/lessons/' + activeEvent.lesson_id">{{ activeEvent.name }}</a>
            </template>
            <template v-else>
              {{ activeEvent.name }}
            </template>
          </small>
          <br>
          <small class="text-muted mr-3">
            {{ trans('core.at') }} {{ activeEvent.date }} | {{ activeEvent.time }}
          </small>

          <div>
            <h4>
              {{ activeQuestion.question }}
            </h4>
            <template v-if="activeQuestion.type == &quot;like&quot;">
              <like-question-result
                :responses="activeQuestion.responses"
                :answers="activeQuestion.answers"
              />
            </template>
            <template v-else-if="activeQuestion.type == &quot;five_scale&quot;">
              <five-scale-question-result
                :responses="activeQuestion.responses"
                :answers="activeQuestion.answers"
              />
            </template>
            <template v-else-if="activeQuestion.type == &quot;ten_scale&quot;">
              <ten-scale-question-result
                style="margin: auto"
                :responses="activeQuestion.responses"
                :answers="activeQuestion.answers"
              />
            </template>
            <template v-else-if="activeQuestion.type == &quot;six_scale&quot;">
              <six-scale-question-result
                style="margin: auto"
                :responses="activeQuestion.responses"
                :answers="activeQuestion.answers"
              />
            </template>
            <template v-else-if="activeQuestion.type == &quot;open&quot;">
              <open-question-result
                :responses="activeQuestion.responses"
                :remarks="activeQuestion.remarks"
              />
            </template>

            <br>
            <span
              v-for="(question, index) in activeEvent.questions"
              v-show="activeEvent.questions.length > 1"
              class="fa cursor-pointer"
              style="padding-right:2px;padding-left:5px;font-size:15px; margin-top:10px;"
              :class="getSquare(question_index == index)"
              @click="changeQuestionIndex(index)"
            />
          </div>
        </div>
      </div>

      <div class="col-xs-2">
        <span
          v-show="events != null && event_index < (events.length - 1)"
          class="fa fa-chevron-right cursor-pointer change"
          @click="changeEventIndex(event_index + 1)"
        />
      </div>

      <div
        class="col-xs-12"
        style="margin-top:30px;"
      >
        <div
          class="progress"
          style="height:2px;"
        >
          <div
            class="progress-bar progress-bar-info"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            :aria-valuenow="percentageOld"
            :style="getWidth(percentageOld)"
            style="background-color:#c8c8c8"
          />
          <div
            class="progress-bar"
            role="progressbar"
            aria-valuemin="0"
            aria-valuemax="100"
            :aria-valuenow="percentage"
            :style="getWidth(percentage)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import LikeQuestionResult from '../../components/results/employees/LikeQuestionResult'
import OpenQuestionResult from '../../components/results/employees/OpenQuestionResult'
import FiveScaleQuestionResult from '../../components/results/employees/FiveScaleQuestionResult'
import TenScaleQuestionResult from '../../components/results/employees/TenScaleQuestionResult'
import SixScaleQuestionResult from '../../components/results/employees/SixScaleQuestionResult'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'ShowEventResult',
  components: { SixScaleQuestionResult, TenScaleQuestionResult, LikeQuestionResult, FiveScaleQuestionResult, OpenQuestionResult },
  props: {
    url: { type: String, required: true },
  },
  data () {
    return {
      events: null,
      question_index: 0,
      event_index: 0,
      loading: true,
    }
  },
  computed: {

    activeEvent () {
      if (this.events == null || this.events[this.event_index] === 'undefined') {
        return null
      } else {
        return this.events[this.event_index]
      }
    },
    activeQuestion () {
      if (this.events == null || this.events[this.event_index] === 'undefined' || this.events[this.event_index].questions[this.question_index] === 'undefined') {
        return null
      } else {
        return this.events[this.event_index].questions[this.question_index]
      }
    },
    percentage () {
      return this.events === null ? 100 : (Math.round(100 / this.events.length))
    },

    percentageOld () {
      return this.events === null ? 0 : (Math.round(100 / this.events.length)) * (this.event_index)
    },

  },

  mounted () {
    this.fetchData()
  },

  methods: {

    fetchData () {
      axios.get(this.url)
        .then(({ data }) => {
          this.events = data.data.data
          this.loading = false
        }).catch(error => defaultErrorMessage(error))
    },
    changeEventIndex (index) {
      this.event_index = index
      this.question_index = 0
    },
    changeQuestionIndex (index) {
      this.question_index = index
    },
    questionsPerEvent (event) {
      if (event.questions === 'undefined') {
        return 0
      } else {
        return event.questions.length
      }
    },

    getSquare (value) {
      return value ? 'fa-square' : 'fa-square-o'
    },
    getWidth (width) {
      return 'width:' + width + '%'
    },
  },

}

</script>

<style scoped>
    .cursor-pointer {
        cursor: pointer;
        color: #e1e1e1;
    }

    .change {
        font-size: 20px;
        margin-top: 50px;
    }
</style>
